<template>
  <div style="background: #fff">
    <quill-editor v-model="quill_value" :options="editorOption" />
  </div>
</template>
<script>
//Vue-Quill Editor
import { quillEditor } from "vue-quill-editor";

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"],
  [{ color: [] }, { background: [] }],
  [{ align: "" }, { align: "right" }, { align: "center" }],
  ["link"],
];

export default {
  name: "basic-quill",
  props: {
    value: {
      type: String,
    },
  },
  components: {
    quillEditor,
  },
  data() {
    return {
      quill_value: this.value,
      editorOption: {
        modules: {
          toolbar: toolbarOptions,
        },
      },
    };
  },
  watch: {
    quill_value(new_val) {
      this.$emit("input", new_val);
    },
    value(new_val) {
      this.quill_value = new_val;
    },
  },
};
</script>
<style scoped>
/* Preserve whitespace in BasicQuill editor */
.quill-editor .ql-editor {
  white-space: pre-wrap;
}

/* Also preserve whitespace in the editor content */
.quill-editor .ql-editor p,
.quill-editor .ql-editor div {
  white-space: pre-wrap;
}
</style>